<section class="common__spacing--between-section">
  <div class="feature-section_heading text-align-center">
    <figure>Page Not Found</figure>
    <p>Oops! Seems you've reached a page that does not exist</p>
    <button (click)="redirect()" class="common--button btn btn-primary">Back</button>
  </div>
</section>
